import { buyNowPopup } from './utils.js'

export function addLoadMore(elem) {

  if(!elem) {
    return
  }

    const loadMore = document.querySelector('.load-more')
    const loader = document.querySelector('.loader')

    let count = 0
    let postAddress = ''

    loadMore.addEventListener('click', (e)=> {
      e.preventDefault()
      const xhr = new XMLHttpRequest()

      loadMore.classList.add('tranparent')
      loader.classList.add('loading')

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {

          loader.classList.remove('loading')

          window.nextPage ++
          setLink()

          const resp = xhr.responseText
          const tempDom = document.createElement('div')
          tempDom.innerHTML = resp

          const elems = Array.from(tempDom.querySelectorAll('.teaser-wrap, .nutrition-thumbnail, .paginating-content'))

          for (let i=0; i<elems.length; ++i) {
            addWithDelayAnim(i, elems[i])
          }

          setTimeout(() => {
              let buyNow = Array.from(document.querySelectorAll('.buyNowPopup'))
              buyNowPopup( Array.from(buyNow) )
          }, (100 * elems.length) )

        }
      };

      xhr.open('POST', postAddress)
      xhr.send()
  })

  const addWithDelayAnim = (i, newElem) => {
   setTimeout(() => {
      elem.append(newElem)
    }, 100 * i)
  }

  const setLink = ()=> {

    if(typeof totalResults == 'undefined') {
      return
    }

    const totalLinks = Math.ceil(totalResults/resultsPerPage)
    const separator = (resultsPage.includes('?')) ? '&' : '?'

    postAddress = resultsPage + separator + 'ccm_paging_p=' + nextPage

    if(totalLinks < nextPage) {
      loadMore.classList.add('tranparent')
    } else {
      loadMore.classList.remove('tranparent')
    }
  }

  setLink()

}



// WEBPACK FOOTER //
// ./src/load-content.js